var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12509_543)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.7502 20.6895L16.0861 15.0254C17.4471 13.3914 18.1258 11.2956 17.981 9.17399C17.8362 7.05236 16.8789 5.06824 15.3085 3.63438C13.738 2.20053 11.6752 1.42733 9.54918 1.47565C7.42316 1.52396 5.39761 2.39006 3.89389 3.89377C2.39018 5.39748 1.52408 7.42304 1.47577 9.54906C1.42746 11.6751 2.20065 13.7379 3.63451 15.3084C5.06836 16.8788 7.05248 17.836 9.17412 17.9809C11.2958 18.1257 13.3915 17.447 15.0255 16.086L20.6896 21.7501L21.7502 20.6895ZM3.00018 9.75006C3.00018 8.41503 3.39606 7.10999 4.13776 5.99996C4.87946 4.88992 5.93366 4.02476 7.16706 3.51387C8.40047 3.00298 9.75766 2.8693 11.067 3.12975C12.3764 3.39021 13.5791 4.03308 14.5231 4.97708C15.4672 5.92109 16.11 7.12382 16.3705 8.4332C16.6309 9.74257 16.4973 11.0998 15.9864 12.3332C15.4755 13.5666 14.6103 14.6208 13.5003 15.3625C12.3902 16.1042 11.0852 16.5001 9.75018 16.5001C7.96058 16.4981 6.24484 15.7863 4.9794 14.5208C3.71396 13.2554 3.00216 11.5397 3.00018 9.75006Z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12509_543"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.d5ed773d0d8f6c2eb1af8404fe4343db.svg";
export { ForwardRef as ReactComponent };